import { render, staticRenderFns } from "./AccountSidebar.vue?vue&type=template&id=05b7cc87&scoped=true&"
import script from "./AccountSidebar.vue?vue&type=script&lang=js&"
export * from "./AccountSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AccountSidebar.vue?vue&type=style&index=0&id=05b7cc87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7cc87",
  null
  
)

export default component.exports